import { withIcon } from '@optimizely/axiom-icons';

export const IconBooksSolid = withIcon(
  {
    icon: [
      20,
      17,
      [],
      '',
      [
        'M3.5 13V14.5H5.5V13H3.5ZM6.25 15.8125C6 15.9375 5.75 16 5.5 16H3.5C2.65625 16 2 15.3438 2 14.5V1.5C2 0.6875 2.65625 0 3.5 0H5.5C5.75 0 6 0.09375 6.25 0.21875C6.46875 0.09375 6.71875 0 7 0H9C9.625 0 10.1875 0.40625 10.4062 1C10.5625 0.78125 10.7812 0.65625 11.0625 0.59375L12.9062 0.0625C13.6875 -0.15625 14.5 0.3125 14.6875 1.125L15.4375 4L17.375 11.4688L17.9375 13.625C18.125 14.4062 17.6875 15.2188 16.9062 15.4375L15.0625 15.9688C14.2812 16.1875 13.4688 15.6875 13.2812 14.9062L12.5312 12.0312L10.5938 4.5625L10.5 4.15625V14.5C10.5 15.3438 9.8125 16 9 16H7C6.71875 16 6.46875 15.9375 6.25 15.8125ZM7 14.5H9V13H7V14.5ZM5.5 1.5H3.5V3H5.5V1.5ZM5.5 4.5H3.5V11.5H5.5V4.5ZM7 3H9V1.5H7V3ZM9 11.5V4.5H7V11.5H9ZM15.75 11.125L14 4.40625L12.2188 4.90625L13.9688 11.625L15.75 11.125ZM14.3438 13.0625L14.7188 14.5L16.5 14L16.125 12.5938L14.3438 13.0625ZM11.8438 3.4375L13.625 2.96875L13.25 1.53125L11.5 2.03125L11.8438 3.4375Z',
      ],
    ],
    iconName: 'books-solid',
    prefix: 'ax',
  },
  'IconBooksSolid'
);
